import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';
import { API_DELETE_CHAT, API_CLEAR_CHAT, API_BLOCK_CHAT } from '../../../../api/chat.service';
import axiosInstance from '../../../../api/axios.instance';
import CustomDialog from '../../../../components/CustomDialog';
import { Text } from '../../../../components/Text';
import { CustomButton } from '../../../../components/CustomButton';
import { resetChatUser } from '../../../../reducers/wca/sales-support/sales-support-slice';
import { actionAlertMessage, initialActionState, menuOption } from './chat-control-constants';
import { useDispatch } from 'react-redux';
import { useUtility } from '../../../../context/UtilityContext';
import {
  blockChatUser,
  unblockChatUser,
} from '../../../../reducers/wca/sales-support/sales-support-action';
import SklbtConfirmation from '../../../../components/common/SklbtConfirmation';
import Loader from '../../../../components/Loader';
import { isTimeOverWCA } from '../../../../utils/chatUtils';
import { useLayout } from '../../../../context/LayoutContext';

const ChatControlMenu = (props) => {
  const { chatInfo } = props;
  const [actionState, setActionState] = useState(initialActionState);
  const [showAlert, setAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedMetadataId } = useUtility();
  const { toast } = useLayout()
  const menuRef = useRef(null);

  const isChatTimeOver = isTimeOverWCA(chatInfo?.lastMessageTimestamp, 24 * 60 * 60 * 1000);


  const handleBlockChat = () => {
    if (isChatTimeOver) {
      toast?.current?.show({
        severity: "info",
        detail: "Chat is already expired, you can not block this contact",
      });
      setAlert(false);
      setLoading(false);
      return
    }
    setLoading(true);
    dispatch(
      blockChatUser({
        metadataid: selectedMetadataId,
        phone: chatInfo.phone,
      }),
    )
      .unwrap()
      .then(() => {
        setAlert(false);
        setLoading(false);
      })
      .catch((err) => err);
  };

  const handleUnBlockChat = () => {
    setLoading(true);
    dispatch(
      unblockChatUser({
        metadataid: selectedMetadataId,
        phone: chatInfo.phone,
      }),
    )
      .unwrap()
      .then(() => {
        setAlert(false);
        setLoading(false);

      })
      .catch((err) => err);
  };


  const updateAaction = (e) => {
    const value = e.item.value;
    setActionState({
      ...initialActionState,
      actionName: value,
      alertMessage: actionAlertMessage[value],
    });
    setAlert(true);
  };
  const blockItem = {
    label: 'Block',
    value: menuOption.BLOCK,
    command: updateAaction,
  };

  const unBlockItem = {
    label: 'Unblock',
    value: menuOption.UNBLOCK,
    command: updateAaction,
  };

  const items = [];

  const cancelAction = () => {
    setAlert(false);
    setActionState(initialActionState);
  };

  const executeAction = () => {
    switch (actionState.actionName) {
      case menuOption.BLOCK:
        handleBlockChat();
        break;
      case menuOption.UNBLOCK:
        handleUnBlockChat();
        break;
      default:
        return;
    }
  };
  const isUserBlocked = chatInfo?.isOptOut;
  if (!isUserBlocked) {
    items.unshift(blockItem);
  } else {
    items.unshift(unBlockItem);
  }

  return (
    <div className="card flex justify-content-center">
      <Loader visible={loading} />
      <SklbtConfirmation
        icon="pi pi-trash"
        message={actionState.alertMessage}
        visible={showAlert}
        handleConfirm={executeAction}
        handleReject={() => cancelAction}
      />


      <Menu model={items} popup ref={menuRef} id="popup_menu_left" />
      <Button
        icon="pi pi pi-ellipsis-v"
        rounded
        text
        className="h-auto"
        onClick={(event) => menuRef.current.toggle(event)}
        aria-controls="popup_menu_left"
        aria-haspopup
      />
    </div>
  );
};

export default ChatControlMenu;
